import { useMutation } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { parseError } from '@/utils/axios';

import { channelsQueryKeys } from './query-keys';

export type TDeleteBroadcastersParams = {
  id: string;
};

export function deleteChannel({ id }: TDeleteBroadcastersParams): Promise<unknown> {
  return mediaManagerClient.delete(`/api/v1/channels/${id}`);
}

type MutationFn = typeof deleteChannel;

type TUseDeleteBroadcastersParams = {
  config?: MutationConfig<MutationFn>;
};

export function useDeleteChannel({ config }: TUseDeleteBroadcastersParams = {}) {
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    onError(error) {
      const { status } = parseError(error);
      console.error(error);

      if (status === 404) {
        return addErrorNotification('La emisora no existe');
      }
      addErrorNotification('No se ha podido eliminar la emisora');
    },
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: channelsQueryKeys.all });
      addSuccessNotification('La emisora se ha eliminado correctamente');
    },
    ...config,
    mutationFn: deleteChannel,
  });
}
